export const common = {
  JwtTokenId: 'id_token',
  backendUrl: '',
  passwordPattern: /(?=^.{8,30}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&;*()_+}{":'?><,]).*$/
};
